module.exports = __webpack_public_path__ + "src/assets/images/shield.svg?576b0bc7c884c243f1a93706528db727";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shield.svg
// module id = 1061
// module chunks = 1